import { DfmFilesState } from "./dfm-files.state";
import { ActionTypes } from "./dfm-files.actions";

export const DfmFilesReducer = (
    state: DfmFilesState = new DfmFilesState(),
    action: any,
  ): DfmFilesState => {

    switch (action.type) {

        case ActionTypes.GetDfmFiles: {
            return {
                ...state,
                loading: true
            };
        }

        case ActionTypes.GetDfmFilesSucceed: {
            const morePagesMode = (action.response.totalPages == null);
            return {
                ...state,
                record: action.response.items,
                pager: {
                    pageSize: action.pageSize,
                    page: action.page,
                    pageCount: morePagesMode ? action.response.morePages : action.response.totalPages,
                    morePagesMode
                },
                loading: false,
                error: null,
                ...action.stateExtensions
            };
        }

        case ActionTypes.GetDfmFilesFail: {
            return {
                ...state,
                record: [],
                loading: false,
                error: action.error
            };
        }

        case ActionTypes.SortDfmFiles: {
            return {
                ...state,
                loading: true,
                sorting: action.sorting
            };
        }

        case ActionTypes.FilterDfmFiles: {
            return {
                ...state,
                loading: true,
                filter: action.filter
            };
        }

        default: {
            return state;
        }
    }

};
